import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import trackedViewComponent from '../hoc/trackedViewComponent';
import { loadDiscoverPage } from '../actions/discover';
import dataComponent from '../hoc/dataComponent';
import { selectDiscoverPageResult, selectHotlinkItems } from '../selectors/discover';
import { DISCOVER_PAGE_TYPE_HOME, META_TITLE_PREFIX } from '../constants';

import DiscoverGroupList from '../components/discover/DiscoverGroupList';
import { defineMessages } from 'react-intl';
import * as clientActions from '../actions/client';

const messages = defineMessages({
  metaTitle: {
    id: 'discover.meta.title-2',
    defaultMessage: 'Discover Classical Music | Stream and Listen Offline',
  },
  metaDescription: {
    id: 'discover.meta.description',
    defaultMessage:
      'Discover the best of classical music on IDAGIO with curated playlists, classical releases, award winning albums and much more!',
  },
  metaKeywords: {
    id: 'discover.meta.keywords',
    defaultMessage:
      'classical music playlists, discover classical music, classical music albums, classical releases, curated classical music playlists, listen to classical music',
  },
});

const getPageByParams = params => {
  return params.page || DISCOVER_PAGE_TYPE_HOME;
};

const getIsHomePage = page => page === DISCOVER_PAGE_TYPE_HOME;
const getHasBanner = page => page === DISCOVER_PAGE_TYPE_HOME;

export async function fetchData(store, params, location, intl) {
  await store.dispatch(loadDiscoverPage(params.page || DISCOVER_PAGE_TYPE_HOME));
  const page = getPageByParams(params);
  const isHomePage = getIsHomePage(page);
  const hasBanner = getHasBanner(page);
  const result = selectDiscoverPageResult(store.getState(), page, isHomePage, hasBanner);
  const { title, subtitle } = result;
  store.dispatch(
    clientActions.setHelmet({
      title: !hasBanner
        ? META_TITLE_PREFIX + (title || intl.formatMessage(messages.metaTitle))
        : META_TITLE_PREFIX + intl.formatMessage(messages.metaTitle),
      description: !hasBanner ? subtitle : intl.formatMessage(messages.metaDescription),
      keywords: intl.formatMessage(messages.metaKeywords),
      canonicalRoute: isHomePage ? '/discover' : `/discover/${page}`,
    })
  );
}

export const trackingProps = (state, params) => {
  const page = getPageByParams(params);

  return {
    isSubPage: page !== DISCOVER_PAGE_TYPE_HOME,
    subPageId: page,
  };
};

export function mapStateToProps(state, ownProps) {
  const page = getPageByParams(ownProps.params);
  const isHomePage = getIsHomePage(page);
  const hasBanner = getHasBanner(page);

  let hotlinkItems;
  if (isHomePage) {
    hotlinkItems = selectHotlinkItems(state);
  }

  return {
    result: selectDiscoverPageResult(state, page, isHomePage, hasBanner),
    trackingScreen: 'discover',
    slug: page,
    isHomePage,
    hasBanner,
    hotlinkItems,
  };
}

export default compose(
  trackedViewComponent('Discover', trackingProps),
  connect(mapStateToProps),
  dataComponent(fetchData),
  withRouter
)(DiscoverGroupList);
